module.exports = __webpack_public_path__ + "static/img/insta-normal.2378763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-simulation/insta-normal.png
// module id = oTTI
// module chunks = 1